export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-7.png?ad21d422929659ba8d01d04a0516a2bc";